import Card, { CardBody, CardHeader, CardRow } from "components/partials/card/card";

import { useCurrentCampaign } from "hooks/api/use-campaigns";
import { useCurrentClient } from "hooks/api/use-clients";
import { useTouchpointVersions } from "hooks/api/use-touchpoint-versions";

import type { EmailAttributes } from "hooks/api/use-touchpoint-versions";

import { TouchpointStatuses } from "types";

import { TouchpointCardProps } from "containers/admin/clients/touchpoint/tab-components/details-tab/details-tab.types";

const IterableTemplateIdsCard = ({ touchpoint, ...rest }: TouchpointCardProps) => {
  const currentClient = useCurrentClient();
  const currentCampaign = useCurrentCampaign();
  const { data: touchpointVersions } = useTouchpointVersions({
    clientId: currentClient.id,
    campaignId: currentCampaign.id,
    touchpointId: touchpoint.id,
  });
  const publishedTouchpoint = touchpointVersions?.items.find(
    (t) => t.status === TouchpointStatuses.PUBLISHED,
  );

  const publishedEmail = publishedTouchpoint && (publishedTouchpoint as EmailAttributes);

  return (
    <Card {...rest}>
      <CardHeader heading="Iterable TemplateIDs" />
      <CardBody>
        <CardRow title="Client TemplateID" value={touchpoint.id} />
        <CardRow title="Base TemplateID" value={publishedEmail?.iterableTemplateId} />
        <CardRow
          title="Workflow Email Template IDs"
          value={publishedEmail?.iterableChildTemplateIds}
        />
      </CardBody>
    </Card>
  );
};

export default IterableTemplateIdsCard;
